import { Signal } from '@angular/core';
import { DialogService, GridButton } from '@eforall/dashboard';
import { AcceleratorAreaService } from '../../../../accelerator-area.service';
import { MarkAllGraduatedDialog } from '../mark-all-graduated-dialog/mark-all-graduated.dialog';


export function getButtons(dialogService: DialogService, accAreaService: AcceleratorAreaService, canVenturesBeGraduated: Signal<boolean>): GridButton[] {

	const buttons: GridButton[] = [];

	const graduate: GridButton = {
		iconClass: 'fa-graduation-cap',
		label: 'Mark All Graduated',
		execute: async () => {
			if (!canVenturesBeGraduated()) {
				await dialogService.showMessage(`Cannot Graduate Ventures`, `Please resolve all issues to be able to mark all Ventures as Graduated.`, 'Okay', [], 300, 200);
				return;
			}

			await dialogService.showCustom(MarkAllGraduatedDialog, {}, 900, 600);
		}
	};

	if (accAreaService.canEdit()) {
		buttons.push(graduate);
	}

	return buttons;
}